/**
 * NSM Coming Soon teaser block — left copy, right waitlist card.
 * Uses site config; main action is the embedded Brevo waitlist form.
 */
import React from "react";
import { Link } from "react-router-dom";
import { site } from "../../config/site";
import WaitlistEmbed from "./WaitlistEmbed";

export default function ComingSoonTeaser() {
  return (
    <section className="buy-ticket">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="buy-ticket__left wow fadeInLeft" data-wow-delay="100ms">
              <p className="main-slider__sub-title" style={{ marginBottom: 8 }}>{site.eventName}</p>
              <h3 className="buy-ticket__title">{site.heroTitle}</h3>
              <p className="buy-ticket__text">{site.heroTagline}</p>
              <p className="buy-ticket__text" style={{ marginTop: 12, opacity: 0.9 }}>
                {site.dateLocationTeaser}
              </p>
              <p className="buy-ticket__text" style={{ marginTop: 20 }}>
                <Link to="/gallery" className="nsm-hero-gallery-link">Explore Gallery</Link>
              </p>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="buy-ticket__right wow fadeInRight" data-wow-delay="300ms">
              <WaitlistEmbed />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
